import React, { Component } from "react";
import {
  Modal,
  Button,
  Spinner,
  ListGroup,
  Table,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import Select from "react-select";
import CartContext from "./CartContext";

/* =========================================================
   ORDER LABEL MANAGER – SINGLE FILE
   ========================================================= */

export const getNumberOfLabelsInputValue = (value) => {
  if (value === null || value === undefined) return 1;
  return value;
};

export const getEffectiveNumberOfLabels = (value) => {
  if (value === null || value === undefined || value === "") return 1;

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
};

export const getEffectiveQty = (qty, numberOfLabels) => {
  const parsedQty = Number(qty);
  if (!Number.isFinite(parsedQty) || parsedQty <= 0) return 0;
  return parsedQty * getEffectiveNumberOfLabels(numberOfLabels);
};

export default class OrderLabelManager extends Component {
  static contextType = CartContext;

  state = {
    /* modal */
    show: false,

    skuScan: "",
    customerName: "",
    mobileNo: "",

    /* left panel */
    orders: [],
    loadingOrders: false,
    selectedOrder: null,

    /* editor */
    orderId: null,
    products: [],
    units: [],
    tanks: [],
    partitions: [],
    selectedProduct: null,
    orderItems: [],
    saving: false,

    labelConfig: {
      width: 50,
      height: 25,
      unit: "mm", // mm | cm
    },

    /* print */
    showPrintPreview: false,
    labelSize: "THERMAL", // THERMAL | A6 | A4
  };

  printOrderSheet = async () => {
    if (!this.validateCustomerDetails()) return;

    if (!this.state.orderItems.length) {
      alert("Add at least one item before printing.");
      return;
    }

    // Quotation number comes from the saved order; save first if needed
    let quotationNo = this.state.selectedOrder?.orderNo;
    if (!quotationNo) {
      const saved = await this.saveOrder();
      if (!saved) return;
      quotationNo = saved.orderNo;
    }

    const items = this.state.orderItems;

    const storeName = this.context.storeSettings?.storeName || "";
    const shipping = this.context.shippingDetails || {};

    const address = `
    ${shipping.Address || ""}, 
    ${shipping.city || ""}, 
    ${shipping.state || ""}, 
    ${shipping.country || ""} - ${shipping.Pincode || ""}
  `;

    const rows = items
      .map((i) => {
        const sp = this.sellingPrice(i);
        const effectiveQty = getEffectiveQty(i.qty, i.numberOfLabels);

        return `
      <tr>
        <td>${i.name}</td>
        <td style="text-align:center">${effectiveQty}</td>
        <td style="text-align:right">${i.mrp.toFixed(2)}</td>
        <td style="text-align:right">${i.discount.toFixed(2)}%</td>
        <td style="text-align:right">${i.gst.toFixed(2)}</td>
        <td style="text-align:right">${sp.toFixed(2)}</td>
        <td style="text-align:right">${(sp * i.qty * (i.numberOfLabels || 1)).toFixed(2)}</td>
      </tr>
    `;
      })
      .join("");

    const totals = this.totals();

    const safeCustomer = (this.state.customerName || "Customer").replace(
      /[^a-zA-Z0-9 _-]/g,
      "",
    );
    const safeQuotNo = (quotationNo || "").replace(/[^a-zA-Z0-9_-]/g, "");
    const pdfTitle = safeQuotNo
      ? `${safeQuotNo} - ${safeCustomer}`
      : `${safeCustomer}`;

    const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${pdfTitle}</title>

<style>

body{
  font-family: Arial;
  margin: 25px;
}

.header{
  text-align:center;
}

.store{
  font-size:22px;
  font-weight:bold;
}

.address{
  font-size:12px;
  margin-top:4px;
}

.title{
  margin-top:10px;
  font-size:18px;
  font-weight:bold;
  text-decoration:underline;
}

.customer{
  margin-top:20px;
  font-size:13px;
}

table{
  width:100%;
  border-collapse: collapse;
  margin-top:15px;
}

th, td{
  border:1px solid #000;
  padding:6px;
  font-size:13px;
}

th{
  background:#f0f0f0;
}

tfoot td{
  font-weight:bold;
}

.right{
  text-align:right;
}

.center{
  text-align:center;
}

.totalBox{
  margin-top:20px;
  width:300px;
  float:right;
  border:2px solid #000;
  padding:10px;
  font-size:16px;
  font-weight:bold;
  text-align:right;
}

.note{
  margin-top:60px;
  font-size:12px;
}

.terms{
  margin-top:20px;
  font-size:12px;
}

</style>

</head>

<body>

<div class="header">

<div class="store">${storeName}</div>

<div class="address">${address}</div>

<div class="title">Quotation</div>

</div>

<div class="customer">

<div><b>Quotation No:</b> ${quotationNo || "-"}</div>
<div><b>Customer:</b> ${this.state.customerName || "-"}</div>
<div><b>Mobile:</b> ${this.state.mobileNo || "-"}</div>
<div><b>Date:</b> ${new Date().toLocaleDateString()}</div>

</div>

<table>

<thead>
<tr>
<th>Product</th>
<th>Qty</th>
<th>MRP</th>
<th>Disc (%)</th>
<th>GST%</th>
<th>Selling Price</th>
<th>Total</th>
</tr>
</thead>

<tbody>
${rows}
</tbody>

<tfoot>
<tr>
<td>Total</td>
<td class="center">${totals.qty}</td>
<td colspan="4"></td>
<td class="right">${totals.amount.toFixed(2)}</td>
</tr>
</tfoot>

</table>

<div class="totalBox">
Grand Total : ₹ ${totals.amount.toFixed(2)}
</div>

<div class="note">
* Prices are inclusive of GST.
</div>

<div class="terms">

<b>Terms & Conditions</b>

<ul>
<li>Quotation valid for 7 days from date of issue.</li>
<li>Goods once sold cannot be returned.</li>
<li>Delivery subject to stock availability.</li>
<li>Payment to be made before delivery.</li>
</ul>

</div>

<script>
window.onload = function(){
  window.print();
}
</script>

</body>
</html>
`;

    const w = window.open("", "_blank");
    w.document.write(html);
    w.document.close();
  };

  generateLabelsArray = () => {
    const labels = [];

    this.state.orderItems.forEach((i) => {
      const count = getEffectiveNumberOfLabels(i.numberOfLabels);

      for (let x = 0; x < count; x++) {
        labels.push(i);
      }
    });

    return labels;
  };

  handleSkuScan = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const scanned = this.state.skuScan.trim().toLowerCase();
    if (!scanned) return;

    // Find product by SKU
    const product = this.state.products.find(
      (p) => (p.sku || "").toLowerCase() === scanned,
    );

    if (!product) {
      alert("SKU not found");
      this.setState({ skuScan: "" });
      return;
    }

    // Build product option structure like Select does
    const unit = this.getUnitName(product.storeUnitId);
    const tank = this.getTankCode(product.tankId);
    const partition = this.getPartitionCode(product.partitionId);

    const option = {
      value: product.id,
      product,
      display: {
        name: product.name,
        sku: product.sku,
        unit,
        tank,
        partition,
        stock: product.inStockQty ?? 0,
      },
    };

    // Auto add
    this.setState({ selectedProduct: option, skuScan: "" }, this.addProduct);
  };

  loadJsBarcode = () => {
    return new Promise((resolve) => {
      if (window.JsBarcode) return resolve();

      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js";
      script.onload = resolve;
      document.body.appendChild(script);
    });
  };

  renderPreviewBarcodes = async () => {
    await this.loadJsBarcode();

    const labels = this.generateLabelsArray(); // 🔥 use expanded labels

    labels.forEach((i, idx) => {
      const el = document.getElementById(`preview-bc-${idx}`);

      if (el && i.sku && window.JsBarcode) {
        window.JsBarcode(el, `${i.sku};${i.qty}`, {
          format: "CODE128",
          height: 18,
          width: 1.25,
          margin: 0,
          displayValue: false,
        });
      }
    });
  };

  /* ================= OPEN / CLOSE ================= */

  open = async () => {
    await this.loadMasters();
    this.setState({ show: true }, this.loadOrders);
  };

  close = () => {
    this.setState({
      show: false,
      selectedOrder: null,
      orderId: null,
      orderItems: [],
      selectedProduct: null,
    });
  };

  /* ================= API ================= */

  apiHeaders = () => ({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${this.context?.userData?.bearertoken || ""}`,
  });

  /* ================= MASTER DATA ================= */

  loadMasters = async () => {
    const api = process.env.REACT_APP_API;
    const storeId = this.context.storeId;

    const [units, tanks, partitions] = await Promise.all([
      fetch(`${api}StorageUnit?storeId=${storeId}`, {
        headers: this.apiHeaders(),
      }).then((r) => r.json()),

      fetch(`${api}Tank/all?storeId=${storeId}`, {
        headers: this.apiHeaders(),
      }).then((r) => r.json()),

      fetch(`${api}TankPartition/all?storeId=${storeId}`, {
        headers: this.apiHeaders(),
      }).then((r) => r.json()),
    ]);

    const products = [...(this.context.prodsAll || [])]
      .filter((p) => p.hideMe !== true)
      .sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", undefined, {
          sensitivity: "base",
        }),
      );

    this.setState({ products, units, tanks, partitions });
  };

  /* ================= LEFT PANEL ================= */

  loadOrders = async () => {
    const api = process.env.REACT_APP_API;
    const storeId = this.context.storeId;

    this.setState({ loadingOrders: true });
    const r = await fetch(`${api}OrderLabel/recent?storeId=${storeId}`, {
      headers: this.apiHeaders(),
    });
    const orders = await r.json();
    this.setState({ orders, loadingOrders: false });
  };

  loadOrderById = async (id) => {
    const api = process.env.REACT_APP_API;
    const storeId = this.context.storeId;

    const r = await fetch(`${api}OrderLabel/${id}?storeId=${storeId}`, {
      headers: this.apiHeaders(),
    });
    const o = await r.json();

    this.setState({
      selectedOrder: o,
      orderId: o.id,
      remarks: o.remarks,
      customerName: o.customerName || "",
      mobileNo: o.mobileNo || "",
      orderItems: o.orderLabelItems.map((i) => ({
        productId: i.productId,
        name: i.productName,
        sku: i.sku,
        qty: i.qty,
        bagSize: i.bagSize,

        storageUnitId: i.storageUnitId,
        storageUnitName: i.storageUnitName,
        tankId: i.tankId,
        tankCode: i.tankCode,
        partitionId: i.partitionId,
        partitionCode: i.partitionCode,

        mrp: i.mrp,
        discount: i.discount,
        gst: i.gstpercentage,
        // ensure numberOfLabels is restored from either variant returned by API
        numberOfLabels: i.numberOfLabels ?? i.numberOflabels ?? 1,
      })),
    });
  };

  newOrder = () => {
    this.setState({
      selectedOrder: null,
      orderId: null,
      orderItems: [],
      selectedProduct: null,
    });
  };

  /* ================= LOOKUPS ================= */

  getUnitName = (id) =>
    this.state.units.find((u) => u.id === id)?.unitName || "-";

  getTankCode = (id) =>
    this.state.tanks.find((t) => t.id === id)?.tankCode || "-";

  getPartitionCode = (id) =>
    this.state.partitions.find((p) => p.id === id)?.partitionCode || "-";

  /* ================= PRODUCT DROPDOWN ================= */

  getProductOptions = () =>
    this.state.products.map((p) => {
      const unit = this.getUnitName(p.storeUnitId);
      const tank = this.getTankCode(p.tankId);
      const partition = this.getPartitionCode(p.partitionId);

      return {
        value: p.id,
        product: p,

        // label shown when selected
        label: `${p.name} ${p.sku || ""}`,

        // 🔑 searchable text
        searchText: `${p.name} ${
          p.sku || ""
        } ${unit} ${tank} ${partition}`.toLowerCase(),

        display: {
          name: p.name,
          sku: p.sku,
          unit,
          tank,
          partition,
          stock: p.inStockQty ?? 0,
        },
      };
    });

  formatProductOption = ({ display }) => (
    <div>
      <strong>{display.name}</strong>
      {display.sku && <span> | {display.sku}</span>}
      <div style={{ fontSize: 12 }}>
        {display.unit} → {display.tank} → {display.partition}
        <span style={{ float: "right" }}>Stock: {display.stock}</span>
      </div>
    </div>
  );

  /* ================= PRICING (GST INCLUSIVE) ================= */

  sellingPrice = (i) => {
    const mrp = Number(i.mrp) || 0;
    const discount = Number(i.discount) || 0;
    const gst = Number(i.gst) || 0;

    const afterDiscount = mrp - (mrp * discount) / 100;
    const gstAmount = (afterDiscount * gst) / 100;

    return afterDiscount - gstAmount;
  };

  totals = () =>
    this.state.orderItems.reduce(
      (a, i) => {
        const sp = this.sellingPrice(i);

        const effectiveQty =
          Number(i.qty) * getEffectiveNumberOfLabels(i.numberOfLabels);

        a.qty += effectiveQty;
        a.amount += sp * effectiveQty;

        return a;
      },
      { qty: 0, amount: 0 },
    );

  handleOrderKeyDown = (e, order) => {
    const { orders } = this.state;
    const index = orders.findIndex((o) => o.id === order.id);

    switch (e.key) {
      case "Enter":
        e.preventDefault();
        this.loadOrderById(order.id);
        break;

      case "Delete":
        e.preventDefault();
        if (!order.isPrinted) {
          this.deleteOrder(order.id);
        }
        break;

      case "ArrowDown":
        e.preventDefault();
        if (index < orders.length - 1) {
          document.getElementById(`order-${orders[index + 1].id}`)?.focus();
        }
        break;

      case "ArrowUp":
        e.preventDefault();
        if (index > 0) {
          document.getElementById(`order-${orders[index - 1].id}`)?.focus();
        }
        break;

      default:
        break;
    }
  };

  componentDidMount() {
    document.addEventListener("keydown", this.handleGlobalKeys);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleGlobalKeys);
  }

  handleGlobalKeys = (e) => {
    if (!this.state.show) return;

    const tag = e.target.tagName;
    const isTyping =
      tag === "INPUT" || tag === "TEXTAREA" || e.target.isContentEditable;

    if (isTyping) return; // 🔑 STOP HERE

    switch (e.key.toLowerCase()) {
      case "n":
        if (e.ctrlKey) {
          e.preventDefault();
          this.newOrder();
        }
        break;

      case "escape":
        e.preventDefault();
        this.close();
        break;

      default:
        break;
    }
  };

  /* ================= ADD PRODUCT ================= */

  addProduct = () => {
    const opt = this.state.selectedProduct;
    if (!opt) return;

    const p = opt.product;
    const d = opt.display;

    this.setState({
      orderItems: [
        {
          productId: p.id,
          numberOfLabels: 1,
          name: p.name,
          sku: p.sku,
          qty: 1,
          bagSize: p.pieceCount || "",
          inStockQty: p.inStockQty ?? d.stock ?? 0,

          storageUnitId: p.storeUnitId,
          storageUnitName: d.unit,

          tankId: p.tankId,
          tankCode: d.tank,

          partitionId: p.partitionId,
          partitionCode: d.partition,

          mrp: p.mrp || 0,
          discount: p.discount || 0,
          gst: p.gst || 0,

          labelMode: "single",
        },

        ...this.state.orderItems,
      ],

      selectedProduct: null,
    });
  };

  deleteOrder = async (orderId) => {
    if (!orderId) return;

    if (!window.confirm("Delete this order permanently?")) return;

    const api = process.env.REACT_APP_API;

    await fetch(`${api}OrderLabel/${orderId}?storeId=${this.context.storeId}`, {
      method: "DELETE",
      headers: this.apiHeaders(),
    });

    if (this.state.orderId === orderId) {
      this.setState({
        selectedOrder: null,
        orderId: null,
        orderItems: [],
      });
    }

    await this.loadOrders();
  };

  validateCustomerDetails = () => {
    const customerName = this.state.customerName?.trim();
    const mobileNo = this.state.mobileNo?.trim();

    if (!customerName) {
      alert("Customer name is required.");
      return false;
    }

    if (!mobileNo) {
      alert("Mobile number is required.");
      return false;
    }

    return true;
  };

  /* ================= SAVE ================= */

  saveOrder = async () => {
    if (!this.validateCustomerDetails()) return null;

    if (!this.state.orderItems.length) {
      alert("Add at least one item before saving.");
      return null;
    }

    const api = process.env.REACT_APP_API;
    const totals = this.totals();
    const isEdit = !!this.state.orderId;

    const payload = {
      storeId: this.context.storeId,
      createdBy: this.context?.userData?.userName || "system",
      remarks: this.state.selectedOrder?.remarks || "",
      customerName: this.state.customerName,
      mobileNo: this.state.mobileNo,
      totalQty: totals.qty,
      totalAmount: totals.amount,
      orderLabelItems: this.state.orderItems.map((i) => {
        const sp = this.sellingPrice(i);
        return {
          productId: i.productId,
          productName: i.name,
          sku: i.sku,
          qty: i.qty,
          bagSize: i.bagSize,
          // backend EF model expects 'NumberOflabels' -> JSON 'numberOflabels'
          numberOflabels: i.numberOfLabels,
          storageUnitId: i.storageUnitId,
          storageUnitName: i.storageUnitName,
          tankId: i.tankId,
          tankCode: i.tankCode,
          partitionId: i.partitionId,
          partitionCode: i.partitionCode,
          mrp: i.mrp,
          discount: i.discount,
          gstpercentage: i.gst,
          sellingPricePerUnit: sp,
          lineTotal: sp * i.qty * (i.numberOfLabels || 1),
        };
      }),
    };

    const url = isEdit
      ? `${api}OrderLabel/${this.state.orderId}`
      : `${api}OrderLabel`;

    const method = isEdit ? "PUT" : "POST";

    this.setState({ saving: true });

    let saved = null;
    try {
      const r = await fetch(url, {
        method,
        headers: this.apiHeaders(),
        body: JSON.stringify(payload),
      });

      if (r.ok) {
        saved = await r.json().catch(() => null);
      }
    } finally {
      this.setState({ saving: false });
    }

    if (saved) {
      this.setState((s) => ({
        orderId: saved.id ?? s.orderId,
        selectedOrder: {
          ...(s.selectedOrder || {}),
          ...saved,
        },
      }));
    }

    await this.loadOrders();

    return saved;
  };

  /* ================= PRINT ================= */

  handleGenerateLabels = () => {
    if (!this.validateCustomerDetails()) return;

    if (!this.state.orderItems.length) {
      alert("Add at least one item before generating labels.");
      return;
    }

    this.setState({ showPrintPreview: true }, () => {
      setTimeout(this.renderPreviewBarcodes, 100);
    });
  };

  printLabels = () => {
    if (!this.validateCustomerDetails()) return;

    const labels = this.generateLabelsArray();
    if (!labels.length) {
      alert("Add at least one item before printing labels.");
      return;
    }

    const { width, height, unit } = this.state.labelConfig;

    const pageSize = `${width}${unit} ${height}${unit}`;

    const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

<style>
@page {
  size: ${pageSize};
  margin: 0;
}

body {
  margin: 0;
}

.page {
  page-break-after: always;
}

.label {
  width: ${width}${unit};
  height: ${height}${unit};
  border: 1px solid #000;
  padding: 2mm;
  box-sizing: border-box;
  font-family: Arial;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.name {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meta {
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.barcode {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
</head>

<body>

${labels
  .map(
    (i, idx) => `
<div class="page">
  <div class="label">
    <div class="name">${i.name}</div>

    <div class="meta">
      Q:${i.qty} &nbsp; Bag:${i.bagSize || "-"} &nbsp;
      ${i.storageUnitName}-${i.tankCode}-${i.partitionCode}
    </div>

    <div class="barcode">
      <svg id="bc-${idx}"></svg>
    </div>
  </div>
</div>
`,
  )
  .join("")}

<script>
window.onload = function () {

  ${labels
    .map((i, idx) =>
      i.sku
        ? `JsBarcode("#bc-${idx}", "${i.sku};${i.qty}", {
            format: "CODE128",
            height: 14,
            width: 1.2,
            margin: 0,
            displayValue: false
          });`
        : "",
    )
    .join("")}

  // 🔥 VERY IMPORTANT: wait for SVG paint before printing
  setTimeout(function () {
    window.print();
  }, 300);

};
</script>

</body>
</html>
`;

    const w = window.open("", "_blank");
    w.document.write(html);
    w.document.close();
  };

  /* ================= RENDER ================= */

  render() {
    const totals = this.totals();

    return (
      <>
        <Modal
          show={this.state.show}
          onHide={this.close}
          size="xxl"
          backdrop="static"
          dialogClassName="xxlmodal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Order & Labels</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: 0 }}>
            <div style={{ display: "flex", height: "75vh" }}>
              {/* LEFT */}
              <div
                style={{
                  width: "20%",
                  borderRight: "1px solid #ddd",
                  padding: 8,
                }}
              >
                <Button className="w-100 mb-2" onClick={this.newOrder}>
                  + New Order
                </Button>
                {this.state.loadingOrders && <Spinner size="sm" />}
                <ListGroup>
                  {this.state.orders.map((o) => (
                    <ListGroup.Item
                      key={o.id}
                      id={`order-${o.id}`} // 🔑 used for focus movement
                      action
                      tabIndex={0} // 🔑 makes it focusable
                      role="button"
                      active={this.state.orderId === o.id}
                      className="d-flex justify-content-between align-items-start"
                      onClick={() => this.loadOrderById(o.id)}
                      onKeyDown={(e) => this.handleOrderKeyDown(e, o)}
                    >
                      {/* LEFT: Order info */}
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => this.loadOrderById(o.id)}
                      >
                        <b>{o.orderNo}</b>

                        {o.customerName && (
                          <>
                            <br />
                            <small style={{ color: "#000" }}>
                              👤 {o.customerName}
                            </small>
                          </>
                        )}

                        <br />

                        <small>
                          Qty:{o.totalQty} ₹{Number(o.totalAmount).toFixed(0)}
                        </small>
                        {o.remarks && (
                          <div>
                            <small>📝 {o.remarks}</small>
                          </div>
                        )}
                        {o.isPrinted && (
                          <div>
                            <small>(Printed)</small>
                          </div>
                        )}
                      </div>

                      {/* RIGHT: Delete */}
                      <Button
                        size="sm"
                        variant="danger"
                        disabled={o.isPrinted}
                        onClick={(e) => {
                          e.stopPropagation(); // 🔑 prevent order selection
                          this.deleteOrder(o.id);
                        }}
                      >
                        Delete
                      </Button>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </div>

              {/* RIGHT */}
              <div style={{ width: "80%", padding: 10 }}>
                <Row className="mb-2">
                  <Col md={6}>
                    <Form.Control
                      placeholder="Customer Name"
                      value={this.state.customerName}
                      onChange={(e) =>
                        this.setState({ customerName: e.target.value })
                      }
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Control
                      placeholder="Mobile Number"
                      value={this.state.mobileNo}
                      onChange={(e) =>
                        this.setState({ mobileNo: e.target.value })
                      }
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <Form.Control
                      placeholder="Remarks (optional)"
                      value={this.state.selectedOrder?.remarks || ""}
                      onChange={(e) => {
                        const remarks = e.target.value;
                        this.setState((s) => ({
                          selectedOrder: {
                            ...(s.selectedOrder || {}),
                            remarks,
                          },
                        }));
                      }}
                    />
                  </Col>
                </Row>
                {/* SKU Scan Field */}
                <Row className="mb-2">
                  <Col md={12}>
                    <Form.Control
                      placeholder="Scan or enter SKU and press Enter"
                      value={this.state.skuScan}
                      autoFocus
                      onChange={(e) =>
                        this.setState({ skuScan: e.target.value })
                      }
                      onKeyDown={this.handleSkuScan}
                    />
                  </Col>
                </Row>

                {/* Manual Select */}
                <Row className="mb-2">
                  <Col md={10}>
                    <Select
                      value={this.state.selectedProduct}
                      onChange={(v) => this.setState({ selectedProduct: v })}
                      options={this.getProductOptions()}
                      formatOptionLabel={this.formatProductOption}
                      isClearable
                      filterOption={(option, inputValue) =>
                        option.data.searchText.includes(
                          inputValue.toLowerCase(),
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Button className="w-100" onClick={this.addProduct}>
                      Add
                    </Button>
                  </Col>
                </Row>

                <div
                  style={{
                    maxHeight: "45vh",
                    overflowY: "auto",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <Table bordered size="lg">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th style={{ width: "7%" }}>Qty</th>
                        <th style={{ width: "10%" }}>BagSize</th>
                        <th style={{ width: "10%" }}>No.Labels</th>
                        <th style={{ width: "10%" }}>MRP</th>
                        <th>Disc %</th>
                        <th>GST%</th>
                        <th>Selling</th>
                        <th>Total</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.orderItems.map((i, idx) => {
                        const sp = this.sellingPrice(i);
                        return (
                          <tr key={idx}>
                            <td>
                              <div style={{ fontWeight: 600 }}>{i.name}</div>
                              <div style={{ fontSize: 12, color: "#555" }}>
                                {i.storageUnitName} / {i.tankCode} /{" "}
                                {i.partitionCode}
                              </div>
                              <div style={{ fontSize: 12, color: "#0b5" }}>
                                Instock: {i.inStockQty ?? 0}
                              </div>
                            </td>
                            <td style={{ width: "7%" }}>
                              <Form.Control
                                type="number"
                                style={{ minWidth: "5rem" }}
                                value={i.qty}
                                onChange={(e) => {
                                  const it = [...this.state.orderItems];
                                  it[idx].qty = e.target.value;
                                  this.setState({ orderItems: it });
                                }}
                              />
                            </td>
                            <td style={{ width: "10%" }}>
                              <Form.Control
                                style={{ minWidth: "6rem" }}
                                value={i.bagSize}
                                onChange={(e) => {
                                  const it = [...this.state.orderItems];
                                  it[idx].bagSize = e.target.value;
                                  this.setState({ orderItems: it });
                                }}
                              />
                            </td>
                            <td style={{ width: "10%" }}>
                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                style={{ minWidth: "5rem" }}
                                value={getNumberOfLabelsInputValue(
                                  i.numberOfLabels,
                                )}
                                onChange={(e) => {
                                  const it = [...this.state.orderItems];
                                  const digits = e.target.value.replace(
                                    /\D/g,
                                    "",
                                  );
                                  it[idx].numberOfLabels =
                                    digits === "" ? "" : digits;
                                  this.setState({ orderItems: it });
                                }}
                              />
                            </td>

                            <td style={{ width: "10%" }}>
                              <Form.Control
                                type="number"
                                step="0.01"
                                style={{ minWidth: "6rem" }}
                                value={i.mrp}
                                onChange={(e) => {
                                  const it = [...this.state.orderItems];
                                  const value = e.target.value;
                                  it[idx].mrp =
                                    value === "" ? "" : parseFloat(value);
                                  this.setState({ orderItems: it });
                                }}
                              />
                            </td>
                            <td style={{ width: "10%" }}>
                              <Form.Control
                                type="number"
                                step="0.01"
                                style={{ minWidth: "6rem" }}
                                value={i.discount}
                                onChange={(e) => {
                                  const it = [...this.state.orderItems];
                                  const value = e.target.value;
                                  it[idx].discount =
                                    value === "" ? "" : parseFloat(value);
                                  this.setState({ orderItems: it });
                                }}
                              />
                            </td>
                            <td>{i.gst}</td>
                            <td>{sp.toFixed(0)}</td>
                            <td>
                              {(
                                sp *
                                i.qty *
                                getEffectiveNumberOfLabels(i.numberOfLabels)
                              ).toFixed(0)}
                            </td>
                            {/* <td>{i.storageUnitName}</td>
                          <td>{i.tankCode}</td>
                          <td>{i.partitionCode}</td> */}
                            <td>
                              <Button
                                size="sm"
                                variant="danger"
                                onClick={() => {
                                  const it = [...this.state.orderItems];
                                  it.splice(idx, 1);
                                  this.setState({ orderItems: it });
                                }}
                              >
                                ✕
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                      {this.state.orderItems.length > 0 && (
                        <tr className="fw-bold">
                          <td>Total</td>
                          <td>{totals.qty}</td>
                          <td colSpan="5"></td>
                          <td>{totals.amount.toFixed(2)}</td>
                          <td colSpan="4"></td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="text-end">
                  {/* <Form.Select
                    style={{ width: 150, display: "inline-block" }}
                    value={this.state.labelSize}
                    onChange={(e) =>
                      this.setState({ labelSize: e.target.value })
                    }
                  >
                    <option value="THERMAL">Thermal</option>
                    <option value="A6">A6</option>
                    <option value="A4">A4</option>
                  </Form.Select> */}

                  <Button
                    className="ms-2"
                    disabled={
                      !this.state.customerName.trim() ||
                      !this.state.mobileNo.trim()
                    }
                    onClick={this.saveOrder}
                  >
                    {this.state.orderId ? "Update" : "Save"}
                  </Button>

                  <Button
                    className="ms-2"
                    variant="secondary"
                    disabled={
                      !this.state.orderItems.length ||
                      !this.state.customerName.trim() ||
                      !this.state.mobileNo.trim()
                    }
                    onClick={this.printOrderSheet}
                  >
                    Print
                  </Button>

                  <Button
                    className="ms-2"
                    variant="secondary"
                    disabled={
                      !this.state.orderItems.length ||
                      !this.state.customerName.trim() ||
                      !this.state.mobileNo.trim()
                    }
                    onClick={this.handleGenerateLabels}
                  >
                    Generate Labels
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showPrintPreview}
          onHide={() => this.setState({ showPrintPreview: false })}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Label Preview</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* CONFIG */}
            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>Width</Form.Label>
                <Form.Control
                  type="number"
                  value={this.state.labelConfig.width}
                  onChange={(e) =>
                    this.setState({
                      labelConfig: {
                        ...this.state.labelConfig,
                        width: e.target.value,
                      },
                    })
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Height</Form.Label>
                <Form.Control
                  type="number"
                  value={this.state.labelConfig.height}
                  onChange={(e) =>
                    this.setState({
                      labelConfig: {
                        ...this.state.labelConfig,
                        height: e.target.value,
                      },
                    })
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Unit</Form.Label>
                <Form.Select
                  value={this.state.labelConfig.unit}
                  onChange={(e) =>
                    this.setState({
                      labelConfig: {
                        ...this.state.labelConfig,
                        unit: e.target.value,
                      },
                    })
                  }
                >
                  <option value="mm">mm</option>
                  <option value="cm">cm</option>
                </Form.Select>
              </Col>
            </Row>

            {/* PREVIEW */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 12,
                justifyContent: "center",
                background: "#f8f9fa",
                padding: 12,
              }}
            >
              {this.generateLabelsArray().map((i, idx) => (
                <div
                  style={{
                    width: `${this.state.labelConfig.width}${this.state.labelConfig.unit}`,
                    height: `${this.state.labelConfig.height}${this.state.labelConfig.unit}`,
                    border: "1px solid #000",
                    padding: "1.5mm",
                    fontFamily: "Arial",
                    background: "#fff",
                    boxSizing: "border-box",
                    display: "grid",
                    gridTemplateRows: "8mm auto 10mm", // 🔑 final tuned rows
                    rowGap: "0.3mm",
                  }}
                >
                  {/* ROW 1 — PRODUCT NAME (MORE SPACE, OPTICAL BALANCE) */}
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      lineHeight: "1.1",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      paddingTop: "1mm", // 🔑 adds breathing room
                    }}
                  >
                    {i.name}
                  </div>

                  {/* ROW 2 — META */}
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                      justifyContent: "center",
                      gap: "3mm",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span>Q:{i.qty}</span>
                    <span>Bag:{i.bagSize || "-"} </span>
                    <span>
                      {i.storageUnitName}-{i.tankCode}-{i.partitionCode}
                    </span>
                  </div>

                  {/* ROW 3 — BARCODE (FLUSH TO BOTTOM) */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center", // 🔑 vertical centering
                      overflow: "hidden",
                    }}
                  >
                    <svg id={`preview-bc-${idx}`}></svg>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showPrintPreview: false })}
            >
              Close
            </Button>

            <Button
              variant="primary"
              onClick={() =>
                this.setState({ showPrintPreview: false }, this.printLabels)
              }
            >
              Print
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
